import React from 'react';
import styled from 'styled-components';
import { Box, Grid, Paper } from '@material-ui/core';

export const Container = styled(Box)`
  box-sizing: border-box;
  height: 100%;
`;

export const SecondWrapper = styled(Grid)`
  height: 100%;
  box-sizing: border-box;
`;
export const BlocWrapper = styled(({ height, ...otherProps }) => (
  <Paper {...otherProps} />
))`
  height: ${(props) => props.height};
  border-radius: 8px !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08) !important;
`;
